/* eslint-disable no-nested-ternary */
export const bankersRounding = (num, decimalPlaces = 0) => {
  const m = 10 ** decimalPlaces;
  const n = +(decimalPlaces ? num * m : num).toFixed(8); // Avoid rounding errors
  const i = Math.floor(n);
  const f = n - i;
  const e = 1e-8; // Allow for rounding errors in f
  const r =
    f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
  return decimalPlaces ? r / m : r;
};
